import { createContext } from "react";
import { LanguageCurrencyPickerContextType } from "./types";

export const LanguageCurrencyPickerContext =
  createContext<LanguageCurrencyPickerContextType>(
    {} as LanguageCurrencyPickerContextType,
  );
